export default {
  customStoryblokTypes: ['insight', 'adhoc', 'market-insight'],
  freeComponents: ['insight-header', 'insight-caption'],
  defaultBlok: 'BlokGeneric',
  teaserMessages: {
    registered: {
      caption:
        '<p>This insight is available to registered users for free. Register in a few seconds to unlock this insight along with others each week.</p>',
    },
    basic: {
      caption:
        '<p>Asoko Insight provides bespoke research specifically tuned to your project needs. Backed by over 10 years of experience and a database of over 100,00 companies and their associated Executives, Ownership, Board Members and Investments.</p><p>We offer comprehensive solutions to achieve both business insights and execution across Africa.</p>',
    },
    advanced: {
      caption:
        '<p>Asoko Insight provides bespoke research specifically tuned to your project needs. Backed by over 10 years of experience and a database of over 100,00 companies and their associated Executives, Ownership, Board Members and Investments.</p><p>We offer comprehensive solutions to achieve both business insights and execution across Africa.</p>',
    },
  },
  intercomMessage: 'Hi,\nI’m interested in access to paid content',
  conversionCampaigns: [
    'bankerCoverageConversion',
    'bankRelationshipOnboardingConversion',
    'investorDealOriginationConversion',
    'investorDealOriginationConversion',
    'investorIntelligenceConversion',
    'investorResearchConversion',
    'marketMapConversion',
    'mncsDistributionTeamConversion',
    'mncsProcurementTeamConversion',
    'riskAdvisorTeamsConversion',
    'solutionsConversion',
    'sourceCompanyConversion',
    'futureInterest',
    'undpPromo',
    'proposalsPromo',
  ],
}
